import React from "react";
import TableHeader from "../tableheader";
import TableRow from "../tablerow";

class Schedule extends React.Component {

  render() {
    return (
      <table className="table" class="print_css">
        <thead>
          <TableHeader
            day="Day"
            event="Event"
            notes="Notes"
            time="Time"
            where="Location"
          />
        </thead>
        
        <tbody>
          {/* Thursday */}
        
          <TableRow
            color="purple"
            day="Thursday"
            event="Supper"
            notes=""
            time="5:00 pm - 6:00 pm"
            where="Dining Hall"
          />
          
          <TableRow
            color="purple"
            event="Billy Elmquist -"
            notes="&quot;Truth Comes From God&quot;"
            time="6:30 pm - 7:30 pm"
            where="The Chapel"
          />
          
          <TableRow
            color="purple"
            event="Dan Gross -"
            notes="&quot;Right Division Basics&quot;"
            time="7:30 pm - 8:30 pm"
            where="The Chapel"
          />
          
          <TableRow
            color="purple"
            event="Fellowship"
            notes=""
            time="8:30 pm - 10:30 pm"
            where="The Chapel & Dining Hall"
          />

          {/* Friday */}
          <TableRow
            color="blue"
            day="Friday"
            event="Breakfast"
            notes=""
            time="8:00 am - 9:00 am"
            where="Dining Hall"
          />

          <TableRow
            color="blue"
            event="Barney Monroe -"
            notes="&quot;Justification By Grace Through Faith&quot;"
            time="9:30 am - 10:30 am"
            where="The Chapel"
          />
          
          <TableRow
            color="blue"
            event="Larry Gabbard -"
            notes="&quot;A New Creature&quot;"
            time="11:00 am - 12:00 pm"
            where="The Chapel"
          />

          <TableRow
            color="blue"
            event="Lunch"
            notes=""
            time="12:30 pm - 2:00 pm"
            where="Dining Hall"
          />

          <TableRow
            color="blue"
            event=""
            notes="&quot;Mens Meeting&quot;"
            time="2:30 pm - 3:30 pm"
            where="The Chapel"
          />
          
          <TableRow
            color="blue"
            event="Supper"
            notes=""
            time="5:00 pm - 6:00 pm"
            where="Dining Hall"
          />

          <TableRow
            color="blue"
            event="Paul Lucas -"
            notes="&quot;Satans Counterfeits&quot;"
            time="6:30 pm - 7:30 pm"
            where="The Chapel"
          />
          
          <TableRow
            color="blue"
            event="Ron Sorg -"
            notes="&quot;What Does God Want?&quot;"
            time="7:30 pm - 8:30 pm"
            where="The Chapel"
          />

          <TableRow
            color="blue"
            event="Fellowship"
            notes=""
            time="8:30 pm - 10:30 pm"
            where="The Chapel & Dining Hall"
          />

          {/* Saturday */}
          <TableRow
            color="purple"
            day="Saturday"
            event="Breakfast"
            notes=""
            time="8:00 am - 9:00 am"
            where="Dining Hall"
          />

          <TableRow
            color="purple"
            event="Young Men -"
            notes="&quot;Timothy Sessions&quot;"
            time="9:30 am - 11:30 am"
            where="The Chapel"
          />

        <TableRow
            color="purple"
            event=""
            notes="&quot;Womans Meeting&quot;"
            time="11:30 am - 12:30 pm"
            where="The Chapel"
          />
          
          <TableRow
            color="purple"
            event="Lunch"
            notes=""
            time="12:30 pm - 2:00 pm"
            where="Dining Hall"
          />

          <TableRow
            color="purple"
            event="Camp Photo"
            notes="Report to Kadee Luethge"
            time="2:00 pm"
            where="Chapel Yard"
          />
          
          <TableRow
            color="purple"
            event="Supper"
            notes=""
            time="5:00 pm - 6:00 pm"
            where="Dining Hall"
          />
          
          <TableRow
            color="purple"
            event="Paul Lucas -"
            notes="&quot;Are We Growing Up?&quot;"
            time="6:30 pm - 7:30 pm"
            where="The Chapel"
          />
          
          <TableRow
            color="purple"
            event="Speakers"
            notes="&quot;Questions And Answers&quot;"
            time="7:30 pm - 8:30 pm"
            where="The Chapel"
          />

          <TableRow
            color="purple"
            event="Fellowship"
            notes=""
            time="8:30 pm - 10:30 pm"
            where="The Chapel & Dining Hall"
          />

          {/* Sunday */}
          <TableRow
            color="blue"
            day="Sunday"
            event="Breakfast"
            notes=""
            time="8:00 am - 9:00 am"
            where="Dining Hall"
          />

          <TableRow
            color="blue"
            event="Larry Gabbard -"
            notes="&quot;It Takes Three&quot;"
            time="10:00 am - 11:00 pm"
            where="The Chapel"
          />
          
          <TableRow
            color="blue"
            event="Barney Monroe -"
            notes="&quot;The Bond Of Perfectness&quot;"
            time="11:00 am - 12:00 pm"
            where="The Chapel"
          />
          
          <TableRow
            color="blue"
            event="Lunch"
            notes=""
            time="12:30 pm - 2:00 pm"
            where="Dining Hall"
          />

          <TableRow
            color="blue"
            event="Clean Up"
            notes="Cabins, The Chapel, and Dining Hall"
            time="2:00 pm - 3:30 pm"
            where="All Buildings"
          />

        </tbody>
      </table>
    );
  }

}

export default Schedule;
